import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'app/store'

interface AppState {
  farmerId: number | null
  farmerName: string
  farmerPhone: string
  plantixUId: string | null
  location: {
    latitude: number | null
    longitude: number | null
  }
  imageUrl: string | null
  imageDataUrl: string | null
  sourceType: boolean 
}
const initialState: AppState = {
  farmerId: null,
  farmerName: '',
  farmerPhone: '',
  plantixUId: null,
  location: {
    latitude: null,
    longitude: null,
  },
  imageUrl: null,
  imageDataUrl: null,
  sourceType: false,
}

export const app = createSlice({
  name: 'farmerModule',
  initialState,
  reducers: {
    setFarmerId: (state, action: PayloadAction<number>) => {
      state.farmerId = action.payload
    },
    setFarmerName: (state, action: PayloadAction<string>) => {
      state.farmerName = action.payload
    },
    setFarmerPhone: (state, action: PayloadAction<string>) => {
      state.farmerPhone = action.payload
    },
    setPlantixUId: (state, action: PayloadAction<string>) => {
      state.plantixUId = action.payload
    },
     setImageDataUrl: (state, action: PayloadAction<string>) => {
      state.imageDataUrl = action.payload
    },
     setImageUrl: (state, action: PayloadAction<string>) => {
      state.imageUrl = action.payload
    },
     setSourceType: (state, action: PayloadAction<boolean>) => {
      state.sourceType = action.payload
    },
    setLocation: (
      state,
      action: PayloadAction<{ latitude: number; longitude: number }>,
    ) => {
      state.location = {
        latitude: action.payload.latitude,
        longitude: action.payload.longitude,
      }
    },
  },
})

export const {
  setFarmerId,
  setFarmerName,
  setFarmerPhone,
  setPlantixUId,
  setLocation,
  setImageDataUrl,
  setImageUrl,
  setSourceType,
} = app.actions

export const selectFarmerId = (state: RootState) => state.farmerModule.farmerId
export const selectFarmerName = (state: RootState) =>
  state.farmerModule.farmerName

export const selectFarmerPhone = (state: RootState) =>
  state.farmerModule.farmerPhone

export const selectPlantixUId = (state: RootState) =>
  state.farmerModule.plantixUId

export const selectLocation = (state: RootState) => state.farmerModule.location

export const selectImageUrl = (state: RootState) => state.farmerModule.imageUrl
export const selectImageDataUrl = (state: RootState) =>
  state.farmerModule.imageDataUrl
export const selectImageSourceType = (state: RootState) =>
  state.farmerModule.sourceType

export default app.reducer
